module.exports = __webpack_public_path__ + "img/icon-reload.e898da5f.svg";